export const FORM_NAME = {
  CONVERSION: 'NEW CONVERSION',
  REVIEW: 'REVIEW',
};
